import {
  Component,
  ViewEncapsulation,
  Output,
  EventEmitter,
  HostListener,
  ViewChild,
} from '@angular/core';
import Keyboard from 'simple-keyboard';
import KeyboardLayouts from 'simple-keyboard-layouts';
import { KeyboardService } from './keyboard.service';

@Component({
  selector: 'app-keyboard',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.sass'],
})
export class KeyboardComponent {
  @ViewChild('keyboard')
  keyboardElement: any;
  keyboard: Keyboard;
  keyboardLayouts: any;
  layouts: Array<any>;
  layoutsObj: any;
  selectedLayout: string = 'english';
  inputName: string;
  @Output() clickOutside = new EventEmitter<void>();

  inputValue: any;
  shiftActive: boolean;
  field: HTMLInputElement;
  keyboardChange: EventEmitter<any>;

  constructor(public keyboardService: KeyboardService) {
    this.keyboardLayouts = new KeyboardLayouts();
    this.layoutsObj = this.keyboardLayouts.get();
    this.layouts = Object.keys(this.layoutsObj).map((layoutName) => ({
      name: layoutName,
      value: this.layoutsObj[layoutName],
    }));

    this.keyboardService.keyboardOnInputFocus.subscribe((data: {emitter: EventEmitter<any>, event: any}) => {
      this.keyboardChange = data.emitter;
      this.onInputFocus(data.event)
  });

    this.keyboardService.keyboardOnInputChange.subscribe((event: any) =>
      this.onInputChange(event)
    );
  }

  public initialiseKeyboard() {
    this.selectedLayout = 'brazilian';

    this.keyboard = new Keyboard({
      debug: true,
      inputName: this.inputName,
      onChange: (input) => this.onChange(input),
      onKeyPress: (button) => this.onKeyPress(button),
      preventMouseDownDefault: true, // If you want to keep focus on input
      disableCaretPositioning: this.field.classList.contains('decimal') ? true : false,
      newLineOnEnter: true,
      layout: {
        default: [this.layoutsObj[this.selectedLayout].layout.default][0],
        shift: [this.layoutsObj[this.selectedLayout].layout.shift][0],
        numeric: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {enter}'],
        decimal: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {enter}'],
      },
      buttonTheme: [
        {
          class: 'hg-enter',
          buttons: '{enter}',
        },
      ],
      display: {
        '{enter}': '↩',
        '{bksp}': '⌫',
        '{space}': ' ',
        '{shift}': '⇪',
        '{lock}': '🄰',
        '{tab}': '⇄',
      },
    });

    this.keyboardService.deactiveKeyboard();
    /**
     * Since we have default values for our inputs,
     * we must sync them with simple-keyboard
     */
    /*    this.keyboard.replaceInput(this.inputs);*/
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: any) {
    var keyboard = document.getElementsByClassName('simple-keyboard')[0];
    if (keyboard)
      if (keyboard !== target && !keyboard.contains(target))
        if (
          !target.classList.contains('mat-input-element') ||
          !this.keyboardService.keyboardIsOpen()
        ) {
          this.clickOutside.emit();
          this.closeKeyboard();
        }
  }

  onInputFocus = (event: any) => {
    this.field = event.target;

    if (this.keyboardService.keyboardIsOpen()) {
      if (!this.keyboard) this.initialiseKeyboard();

      this.inputName = event.target.id;
      this.keyboardService.keyboardValue = event.target.value;

      var layout = 'default';
      if (event.target.classList.contains('numeric')) {
        layout = 'numeric';
      }

      if (event.target.classList.contains('decimal')) layout = 'decimal';

      this.keyboard.setOptions({
        inputName: event.target.id,
        layoutName: layout,
      });

      //if (!this.showKeyboard) {
      setTimeout(() => {
        this.keyboardService.activeKeyboard();
        console.log(
          'keyboard shown ' + this.keyboardService.keyboardIsActive()
        );
      }, 100);
      //}

      this.keyboard.setInput(event.target.value);
    }
  };

  setInputCaretPosition = (elem: any, pos: number) => {
    if (elem.setSelectionRange) {
      elem.focus();
      elem.setSelectionRange(pos, pos);
    }
  };

  onInputChange = (event: any) => {
    this.keyboardService.keyboardValue = event.value;
    this.keyboard?.setInput(event.value, event.id);
  };

  onChange(input: string) {
    this.keyboard.setInput(input);

    this.keyboardService.keyboardValue = input;
    this.inputValue = input;

    if (this.field) {
      if (this.field.classList.contains('decimal')) {
        input = input.replace(/[^0-9]/g, '');

        let initial = input.slice(0, input.length - 2);
        let final = input.slice(-2);

        input = initial +'.'+ final;

        this.setInputCaretPosition(
          document.querySelector(`#${this.inputName}`),
          input.length -1
        );
      } else {
        input = this.correctAccents(input);
        this.field.value = input;
      }

      this.field.dispatchEvent(new Event('input'));

      this.keyboardChange.emit(input);
    }
    //this.systemParametersForm.controls[this.inputName].setValue(input);

    /**
     * Synchronizing input caret position
     * This part is optional and only relevant if using the option "preventMouseDownDefault: true"
     */
    let caretPosition = this.keyboard.caretPosition;

    if (caretPosition !== null)
      this.setInputCaretPosition(
        document.querySelector(`#${this.inputName}`),
        caretPosition
      );
  }
  correctAccents(input: string): string {
     // has especial chars and endswith special char
     if(input.length > 1 && input.match(/[´`~^]/) && (!input.endsWith('´') || !input.endsWith('`') || !input.endsWith('~') || !input.endsWith('^'))) {
      this.setInputCaretPosition(
        document.querySelector(`#${this.inputName}`),
        input.length -2
      );
     }

    input = input.replace("´A", 'Á');
    input = input.replace("´a", 'Á');
    input = input.replace("`A", 'À');
    input = input.replace("`a", 'à');

    input = input.replace("´E", 'É');
    input = input.replace("´e", 'é');
    input = input.replace("`E", 'È');
    input = input.replace("`e", 'è');

    input = input.replace("´I", 'Í');
    input = input.replace("´i", 'í');
    input = input.replace("`I", 'Ì');
    input = input.replace("`i", 'ì');

    input = input.replace("´O", 'Ó');
    input = input.replace("´o", 'ó');
    input = input.replace("`O", 'Ò');
    input = input.replace("`o", 'ò');

    input = input.replace("´U", 'Ú');
    input = input.replace("´u", 'ú');
    input = input.replace("`U", 'Ù');
    input = input.replace("`u", 'ù');

    input = input.replace("~A", 'Ã');
    input = input.replace("~a", 'ã');
    input = input.replace("~O", 'Õ');
    input = input.replace("~o", 'õ');
    input = input.replace("~N", 'Ñ');
    input = input.replace("~n", 'ñ');

    input = input.replace("^A", 'Â');
    input = input.replace("^a", 'â');
    input = input.replace("^E", 'Ê');
    input = input.replace("^e", 'ê');
    input = input.replace("^I", 'Î');
    input = input.replace("^i", 'î');
    input = input.replace("^O", 'Ô');
    input = input.replace("^o", 'ô');
    input = input.replace("^U", 'Û');
    input = input.replace("^u", 'û');

    input = input.replace("´C", 'Ç');

    return input;
  }

  onKeyPress = (button: string) => {
    if (this.shiftActive) {
      this.shiftActive = false;
      this.handleShift(button);
    }

    if (button === '{enter}') this.closeKeyboard();

    if (button === '{clr}') this.keyboard.clearInput(this.inputName);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') this.handleShift(button);
  };

  handleShift = (button: any) => {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === 'default' ? 'shift' : 'default';

    if (button === '{shift}') this.shiftActive = true;
    else this.shiftActive = false;

    this.keyboard.setOptions({
      layoutName: shiftToggle,
    });
  };

  closeKeyboard() {
    this.keyboardService.deactiveKeyboard();
  }
}
